export enum SqlRole {
  admin = "admin",
  salesAdmin = "sales_admin",
  accountant = "accountant",
  foreman = "foreman",
  seller = "seller",
}

export const Roles: Record<string, SqlRole> = {
  Admin: SqlRole.admin,
  SalesAdmin: SqlRole.salesAdmin,
  Accountant: SqlRole.accountant,
  Foreman: SqlRole.foreman,
  Seller: SqlRole.seller,
};

export const RolesNames: Record<SqlRole, string> = {
  admin: "Administrateur",
  sales_admin: "Administrateur des ventes",
  accountant: "Comptable",
  foreman: "Responsable travaux",
  seller: "Mandataire",
};
